import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-items-sent',
  templateUrl: './items-sent.component.html',
  styleUrls: ['./items-sent.component.css']
})
export class ItemsSentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
